import privateAxiosService from './privateAxiosService.ts';
import type { APITokenResponse } from './privateAxiosService.ts';

export const getUserDemoToken = () =>
  privateAxiosService.post<APITokenResponse>('/auth/demo-token');

export const getUserTokenBySessionId = (sessionid: string, mode: string) =>
  privateAxiosService.post<APITokenResponse>('/auth/token', { sessionid, mode });
